import Game from '../model/game';

/**
 * Game service
 * @type {{init: (function()), getGameSvc: (function())}}
 */
export const GameSvc = {
  /**
   * Initialize game service
   */
  init() {
    this.gameSvc = new Game();
  },

  /**
   * Get game service
   * @returns {Game | GameSvc}
   */
  getGameSvc() {
    return this.gameSvc;
  },
};



// WEBPACK FOOTER //
// game.service.js